<template>
    <el-dialog 
        title="Deny Fulfillment Request"
        :visible.sync="showForm"
    >
        <h4 class="mb-3">Notes</h4>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            v-model="fulfillment.fulfillment_notes">
        </el-input>

        <span slot="footer" class="dialog-footer">
            <btn :click="() => showForm = false" cssClass="btn mr-2" icon="fas fa-times">Close</btn>
            <btn :click="denyRequest" cssClass="btn btn-danger">Deny request</btn>
        </span>
    </el-dialog>
</template>

<script>
export default {
        components: {
        },
        props: [
            'show',
            'fulfillment_id',
            'fulfillment',
        ],
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            denyRequest() {
                return axios.post(url(`de/fulfillment/${this.fulfillment_id}/deny`), {
                    notes: this.fulfillment.fulfillment_notes
                }).then((response) => {
                    this.showForm = false;

                    this.$emit('changed');
                });
            }
        },
        mounted() {
        }
    }
</script>
